import Phaser from 'phaser';

export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
  }

  preload(): void {
    // Boot scene loads minimal assets needed for the loading screen
    // Main assets are loaded in PreloadScene
  }

  create(): void {
    // Boot scene intentionally does minimal work. Immediately transition
    // to the PreloadScene which is responsible for showing the loading UI.
    this.scene.start('PreloadScene');
  }
}
